export function formatDecimal(number: number, decimalPlaces: number = 2) {
  const decimal = decimalPlaces;
  return parseFloat(String(number)).toFixed(decimal);
}
